export const fileConstants = {
    UPLOAD_REQUEST: 'FILE_UPLOAD_REQUEST',
    UPLOAD_SUCCESS: 'FILE_UPLOAD_SUCCESS',
    UPLOAD_FAILURE: 'FILE_UPLOAD_FAILURE',

    CLEAR: 'FILE_CLEAR'
};